import { styled } from 'styled-components';

export const PhaseContainer = styled.div`
  h3 {
    ${({ theme }) => theme.typography.headingSmall}
    color: ${({ theme }) =>
      theme.applyOpacity(theme.colours.ink.primary.main, 'secondary')};
    margin-bottom: ${({ theme }) => theme.sizing.small};
  }

  hr {
    margin: ${({ theme }) => theme.sizing.large}
      ${({ theme }) => theme.sizing.xsmall} !important;
    border-color: ${({ theme }) => theme.colours.canvas.secondary.main};
  }
`;
PhaseContainer.displayName = 'PhaseContainer';

export const PhaseContainerFields = styled.div`
  display: grid !important;
  grid-template-columns: repeat(
    ${({ $numOfGames }) => ($numOfGames < 12 ? 2 : 3)},
    1fr
  );
  grid-template-rows: repeat(
    ${({ $numOfGames }) => Math.min(6, $numOfGames)},
    1.3125rem
  );
  grid-auto-flow: column;
  gap: ${({ theme }) => theme.sizing.small};
  max-height: 10.625rem;
`;
PhaseContainerFields.displayName = 'PhaseContainerFields';

export const CustomLabel = styled.div`
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.small};
  color: ${({ theme }) => theme.colours.ink.primary.main};

  > span {
    border: 0 !important;
    background: transparent !important;
  }

  .round {
    display: flex !important;
    justify-content: center;
    width: 2rem;
    ${({ theme }) => theme.typography.bodyMedium}
  }

  .teams {
    width: 5.3125rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${({ theme }) => theme.typography.bodyMedium}
  }

  .date {
    width: 2.1875rem;
    ${({ theme }) => theme.typography.bodySmall}
  }
`;
CustomLabel.displayName = 'CustomLabel';
